export class AirTimeRegistrationDetailEntity {
  createdAt?: string;
  updatedAt?: string;
  id?: string;
  name?: string;
  code?: string;
  description?: string;
  order?: number;
  type?: number;
  status?: number;
  note?: string;
  totalAmount?: string | number;
  commissionAmount?: string | number;
  transRef?: string | null;
  ownerId?: string;
  user?: AirTimeRegistrationUserEntity;
  paymentMethod?: AirTimeRegistrationPaymentMethodEntity;
  service?: AirTimeRegistrationServiceEntity;
  transactionDetail?: AirTimeRegistrationTransactionDetailEntity;
  product?: AirTimeRegistrationProductEntity;
  paymentMethods?: AirTimeRegistrationPaymentMethodEntity | Record<string, unknown>;
  platform?: string;

  constructor(data?: Partial<AirTimeRegistrationDetailEntity>) {
    Object.assign(this, data);
  }
}

export class AirTimeRegistrationUserEntity {
  createdAt?: string;
  updatedAt?: string;
  id?: string;
  userName?: string;
  name?: string;
  code?: string;
  email?: string | null;
  fullName?: string | null;
  birthDay?: string | null;
  phone?: string;
  description?: string | null;
  type?: number;
  status?: number;
  address?: string | null;
  confirmPayment?: number;
  taxCode?: string;
  isVerified?: boolean;
  note?: string | null;
  avatar?: string;
  partner?: unknown;
  parent?: unknown;

  constructor(data?: Partial<AirTimeRegistrationUserEntity>) {
    Object.assign(this, data);
  }
}

export class AirTimeRegistrationPaymentMethodEntity {
  createdAt?: string;
  updatedAt?: string;
  id?: string;
  name?: string;
  displayName?: string;
  code?: string;
  description?: string;
  cover?: string;
  url?: string;
  configuration?: Record<string, unknown>;
  items?: unknown;
  type?: number;
  status?: number;
  order?: number;
  supplier?: string;

  constructor(data?: Partial<AirTimeRegistrationPaymentMethodEntity>) {
    Object.assign(this, data);
  }
}

export class AirTimeRegistrationServiceEntity {
  name?: string;
  code?: string;
  iconUrl?: string;

  constructor(data?: Partial<AirTimeRegistrationServiceEntity>) {
    Object.assign(this, data);
  }
}

export class AirTimeRegistrationTransactionDetailEntity {
  createdAt?: string;
  updatedAt?: string;
  id?: string;
  name?: string | null;
  code?: string;
  description?: string | null;
  order?: number;
  type?: number;
  status?: number;
  note?: string | null;
  info?: {
    totalAmount?: number;
    discountRate?: number;
    discountAmount?: number;
    amount?: Array<{
      value?: number;
      name?: string;
    }>;
  };
  buyer?: AirTimeRegistrationBuyerEntity;

  constructor(data?: Partial<AirTimeRegistrationTransactionDetailEntity>) {
    Object.assign(this, data);
  }
}

export class AirTimeRegistrationBuyerEntity {
  createdAt?: string;
  updatedAt?: string;
  id?: string;
  name?: string;
  email?: string;
  phone?: string;
  address?: string;
  type?: number;
  status?: number;
  extra?: string;

  constructor(data?: Partial<AirTimeRegistrationBuyerEntity>) {
    Object.assign(this, data);
  }
}

export class AirTimeRegistrationProductEntity {
  name?: string;
  code?: string;
  totalAmount?: string | number;
  type?: number;
  detail?: {
    createdAt?: string;
    updatedAt?: string;
    id?: string;
    name?: string;
    code?: string;
    amount?: string;
    status?: number;
    type?: number;
    description?: string | null;
    config?: unknown;
    order?: number;
    carrier?: string;
    totalAmount?: string;
    phoneNumber?: string;
    serial?: string;
    note?: string;
  };

  constructor(data?: Partial<AirTimeRegistrationProductEntity>) {
    Object.assign(this, data);
  }
}
